import zod from "zod";
import { OptionOrderDto } from "../hooks/binance-options-data-service/types/OptionOrderDto";

export function getValidatedOptionsOrder(source: unknown): OptionOrderDto[] | null {
    if (source === null) {
        return null;
    }

    const itemSchema = zod.object({
        orderId: zod.number().int().positive(),
        symbol: zod.string().min(1),
        price: zod.number().finite(),
        quantity: zod.number().finite(),
        side: zod.string().min(1),
        createTime: zod.number().int().nonnegative(),
    });

    const schema = zod.array(itemSchema);
    
    const parsed = schema.safeParse(source);

    if (!parsed.success) {
        console.error(
            parsed.error.issues
                .map((issue) => {
                    const path = issue.path.map(String).join(".");
                    return `${path}: ${issue.message}`;
                })
                .join("; ")
        );

        return null;
    }

    return parsed.data;
}
